export const ICON_NAMES = [
  "award",
  "barChart",
  "brain",
  "briefcase",
  "compass",
  "heart",
  "lightbulb",
  "rocket",
  "star",
  "target",
  "trophy",
  "users",
  "globe",
  "facebook",
  "instagram",
  "linkedin",
  "youtube",
  "message",
  "location",
  "palette",
  "mic",
  "calendar",
  "clock",
  "home",
  "search",
  "dcm",
  "grip-vertical",
] as const;

export type TIconName = (typeof ICON_NAMES)[number];
